module.exports = {
  "signup": {
    "url": `${process.env.REACT_APP_API_PREFIX}/signup`,
    "callback": "api/signup/my"
  },
  "country-list": {
    "url": `${process.env.REACT_APP_API_PREFIX}/country-list`,
    "callback": "api/country-list"
  },
  "user-residential-address": {
    "url": `${process.env.REACT_APP_API_PREFIX}/user/residential-address`,
    "callback": "api/user-residential-address"
  },
  "user-postal-address": {
    "url": `${process.env.REACT_APP_API_PREFIX}/user/postal-address`,
    "callback": "api/user-postal-address"
  },
  "user-emergency-contact": {
    "url": `${process.env.REACT_APP_API_PREFIX}/user/emergency-contact-details`,
    "callback": "api/user-emergency-contact"
  },
  "cv-parsing": {
    "url": `${process.env.REACT_APP_API_PREFIX}/cv-parsing`,
    "callback": "api/cv-parsing"
  },
  "get-branches": {
    "url": `${process.env.REACT_APP_API_PREFIX}/get-branches`,
    "callback": "api/get-branches"
  }
};
